"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.XoneValidationException = void 0;
var Exception_1 = require("./Exception");
var XoneValidationException = /** @class */ (function (_super) {
    __extends(XoneValidationException, _super);
    /**
     *
     */
    function XoneValidationException(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        return _this;
    }
    return XoneValidationException;
}(Exception_1.Exception));
exports.XoneValidationException = XoneValidationException;

//# sourceMappingURL=XoneValidationException.js.map
